/**
 * Role helpers — keep in sync with CustomClaimsPrincipalExtensions (BE).
 * Missing/empty rol defaults to ADMIN (legacy tokens).
 */

function normalizeRol(rol) {
  if (rol == null || String(rol).trim() === "") return "";
  return String(rol).toUpperCase();
}

/** Portal admin: empty | ADMIN | SUPERADMIN */
export function isAdmin(rol) {
  const r = normalizeRol(rol);
  return !r || r === "ADMIN" || r === "SUPERADMIN";
}

/** Exclusive guest (davetli) management */
export function isSuperAdmin(rol) {
  return normalizeRol(rol) === "SUPERADMIN";
}

export function isOperator(rol) {
  return normalizeRol(rol) === "OPERATOR";
}

/** QR scan: SUPERADMIN | OPERATOR */
export function canScanQr(rol) {
  return isSuperAdmin(rol) || isOperator(rol);
}
